import { FC } from 'react';
import { Flex, Text, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { CbButton } from '../..';
import { ButtonVariant } from '../Buttons/CbButton';
export interface CbAreYouSureModalProps {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  subText?: string;
  onConfirm: () => void;
  confirmText: string;
  denyText: string;
  confirmButtonVariant?: ButtonVariant;
}
export const CbAreYouSureModal: FC<CbAreYouSureModalProps> = ({
  isOpen,
  onClose,
  headerText,
  subText,
  onConfirm,
  confirmText,
  denyText,
  confirmButtonVariant = 'primary'
}) => {
  const headerMargin = subText ? 4 : 12;
  return <Modal isCentered isOpen={isOpen} onClose={onClose} size="sm" data-sentry-element="Modal" data-sentry-component="CbAreYouSureModal" data-sentry-source-file="CbAreYouSureModal.tsx">
      <ModalOverlay data-sentry-element="ModalOverlay" data-sentry-source-file="CbAreYouSureModal.tsx" />
      <ModalContent paddingY={8} data-sentry-element="ModalContent" data-sentry-source-file="CbAreYouSureModal.tsx">
        <ModalCloseButton variant="cb-ghost" data-sentry-element="ModalCloseButton" data-sentry-source-file="CbAreYouSureModal.tsx" />
        <ModalHeader marginBottom={headerMargin} textAlign="center" data-sentry-element="ModalHeader" data-sentry-source-file="CbAreYouSureModal.tsx">
          {headerText}
        </ModalHeader>
        {subText && <Text textAlign={'center'} fontSize={'sm'} fontWeight="bold" color="cloud.700" marginBottom={6} width="80%" marginLeft="10%">
            {subText}
          </Text>}
        <ModalBody data-sentry-element="ModalBody" data-sentry-source-file="CbAreYouSureModal.tsx">
          <Flex width="100%" justifyContent={'center'} data-sentry-element="Flex" data-sentry-source-file="CbAreYouSureModal.tsx">
            <CbButton variant="secondary" onClick={onClose} marginRight={4} data-sentry-element="CbButton" data-sentry-source-file="CbAreYouSureModal.tsx">
              {denyText}
            </CbButton>
            <CbButton onClick={onConfirm} marginLeft={4} variant={confirmButtonVariant} data-sentry-element="CbButton" data-sentry-source-file="CbAreYouSureModal.tsx">
              {confirmText}
            </CbButton>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>;
};